import { AutoMap } from "@automapper/classes"
import { EMilieuPrelevementAir } from "src/app/domain/Air/enum/milieu-prelevement"
import { PrelevementDTO } from "./prelevement.dto"
import { EMilieuPrelevementSurface } from "src/app/domain/Surface/enum/milieu-prelevement";
import { AppareilDTO } from "./appareil.dto";

export class PrelevementSurfaceDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    lieuPrelevement!: number;
    @AutoMap()
    autrelieuPrelevement: string = ''
    @AutoMap()
    milieuPrelevement: EMilieuPrelevementSurface = EMilieuPrelevementSurface.BoiteContact
    @AutoMap()
    observations: string = ''
    @AutoMap()
    prelevement: PrelevementDTO = new PrelevementDTO()
    @AutoMap()
    applicateurContact: AppareilDTO = new AppareilDTO()
}